import type { PaymentType } from "@/api-v3";

export type PaymentIcon = "Star" | "Car" | "ReceiptText";

export type PaymentTypeWithAction = Extract<
  PaymentType,
  "stipend" | "micropayment"
>;

export function isPaymentTypeWithAction(
  type: PaymentType
): type is PaymentTypeWithAction {
  return type === "stipend" || type === "micropayment";
}
